import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CFCreateModalUI from './CFCreateModalUI.js'

class CFCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      year: '2023',
      yearError: null,
      month: '',
      monthError: null,
      loanAmount: '',
      loanAmountError: null,
      promoterFund: '',
      promoterFundError: null,
      dsraAmount: '',
      dsraAmountError: null,
      processingFee: '',
      processingFeeError: null,
      emiPayment: '',
      emiPaymentError: null,
      projectExpense: '',
      projectExpenseError: null,
      climeRevenue: '',
      climeRevenueError: null,
      otherRevenue: '',
      otherRevenueError: null,
      notes: '',
      notesError: null,
    }
  }

  render() {
    let yearList = [
      {key: '2022', value: '2022'},
      {key: '2023', value: '2023'},
      {key: '2024', value: '2024'},
      {key: '2025', value: '2025'},
      {key: '2026', value: '2026'},
      {key: '2027', value: '2027'},
      {key: '2028', value: '2028'},
      {key: '2029', value: '2029'},
      {key: '2030', value: '2030'},
      {key: '2031', value: '2031'},
      {key: '2032', value: '2032'},
      {key: '2033', value: '2033'},
      {key: '2034', value: '2034'},
      {key: '2035', value: '2035'},
      {key: '2036', value: '2036'},
      {key: '2037', value: '2037'},
      {key: '2038', value: '2038'},
      {key: '2039', value: '2039'},
      {key: '2040', value: '2040'},
    ]
    let monthList = [
      {key: '0', value: 'January'},
      {key: '1', value: 'February'},
      {key: '2', value: 'March'},
      {key: '3', value: 'April'},
      {key: '4', value: 'May'},
      {key: '5', value: 'June'},
      {key: '6', value: 'July'},
      {key: '7', value: 'August'},
      {key: '8', value: 'September'},
      {key: '9', value: 'October'},
      {key: '10', value: 'November'},
      {key: '11', value: 'December'},
    ]

    return (
      <CFCreateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        selectedCashFlow={this.props.selectedCashFlow}
        // modes
        createMode={this.props.createMode}
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        year={this.state.year}
        onYearChange={(event) => { this.setState({ year: event.target.value }) }}
        yearError={this.state.yearError}
        setYearError={(error) => { this.setState({ yearError: error }) }}
        yearList={yearList}
        month={this.state.month}
        onMonthChange={(event) => { this.setState({ month: event.target.value }) }}
        monthError={this.state.monthError}
        setMonthError={(error) => { this.setState({ monthError: error }) }}
        monthList={monthList}
        //
        loanAmount={this.state.loanAmount}
        onLoanAmountChange={(event) => { this.setState({ loanAmount: event.target.value }) }}
        loanAmountError={this.state.loanAmountError}
        setLoanAmountError={(error) => { this.setState({ loanAmountError: error }) }}
        promoterFund={this.state.promoterFund}
        onPromoterFundChange={(event) => { this.setState({ promoterFund: event.target.value }) }}
        promoterFundError={this.state.promoterFundError}
        setPromoterFundError={(error) => { this.setState({ promoterFundError: error })}}
        dsraAmount={this.state.dsraAmount}
        onDsraAmountChange={(event) => { this.setState({ dsraAmount: event.target.value }) }}
        dsraAmountError={this.state.dsraAmountError}
        setDsraAmountError={(error) => { this.setState({ dsraAmountError: error })}}
        processingFee={this.state.processingFee}
        onProcessingFeeChange={(event) => { this.setState({ processingFee: event.target.value }) }}
        processingFeeError={this.state.processingFeeError}
        setProcessingFeeError={(error) => { this.setState({ processingFeeError: error })}}
        emiPayment={this.state.emiPayment}
        onEmiPaymentChange={(event) => { this.setState({ emiPayment: event.target.value }) }}
        emiPaymentError={this.state.emiPaymentError}
        setEmiPaymentError={(error) => { this.setState({ emiPaymentError: error })}}
        projectExpense={this.state.projectExpense}
        onProjectExpenseChange={(event) => { this.setState({ projectExpense: event.target.value }) }}
        projectExpenseError={this.state.projectExpenseError}
        setProjectExpenseError={(error) => { this.setState({ projectExpenseError: error }) }}
        climeRevenue={this.state.climeRevenue}
        onClimeRevenueChange={(event) => { this.setState({ climeRevenue: event.target.value }) }}
        climeRevenueError={this.state.climeRevenueError}
        setClimeRevenueError={(error) => { this.setState({ climeRevenueError: error }) }}
        otherRevenue={this.state.otherRevenue}
        onOtherRevenueChange={(event) => { this.setState({ otherRevenue: event.target.value }) }}
        otherRevenueError={this.state.otherRevenueError}
        setOtherRevenueError={(error) => { this.setState({ otherRevenueError: error }) }}
        notes={this.state.notes}
        onNotesChange={(event) => { this.setState({ notes: event.target.value }) }}
        notesError={this.state.notesError}
        setNotesError={(error) => { this.setState({ notesError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    let cashFlow = this.props.selectedCashFlow
    if (!cashFlow)
      return
    if (prevProps.selectedCashFlow && prevProps.selectedCashFlow.year == cashFlow.year && prevProps.selectedCashFlow.month == cashFlow.month)
      return

    this.setState({
      year: cashFlow.year,
      month: cashFlow.month,
      loanAmount: cashFlow.loanAmountF3,
      promoterFund: cashFlow.promoterFundF3,
      dsraAmount: cashFlow.dsraAmountF3,
      processingFee: cashFlow.processingFeeF3,
      emiPayment: cashFlow.emiPaymentF3,
      projectExpense: cashFlow.projectExpenseF3,
      climeRevenue: cashFlow.climeRevenueF3,
      otherRevenue: cashFlow.otherRevenueF3,
      notes: cashFlow.notes
    })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/cashFlows`,
      this.onSubmitCallback, {
        year: this.state.year,
        month: this.state.month,
        loanAmountF: this.state.loanAmount,
        promoterFundF: this.state.promoterFund,
        dsraAmountF: this.state.dsraAmount,
        processingFeeF: this.state.processingFee,
        emiPaymentF: this.state.emiPayment,
        projectExpenseF: this.state.projectExpense,
        climeRevenueF: this.state.climeRevenue,
        otherRevenueF: this.state.otherRevenue,
        notes: this.state.notes
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }
}

export default withRouter(CFCreateModalSF)
